import { ALLOCATIONS } from "../constants/actionTypes";
import { AllocationType } from "../types/api/allocations";

/**
 * Action type for setting the available allocations
 * @param token
 */
export function SetAvailableAllocations(allocations: AllocationType[]) {
  return {
    type: ALLOCATIONS.SET_AVAILABLE_ALLOCATIONS,
    allocations
  };
}

/**
 * Action type for setting the selected allocations returned from /allocations/freetransfers
 * @param token
 */
export function SetSelectedAllocations(allocations: AllocationType[], feePeriod?: string) {
  return {
    type: ALLOCATIONS.SET_SELECTED_ALLOCATIONS,
    allocations,
    feePeriod,
  };
}

/**
 * Action type for setting the allocations to submit for update endpoint 
 * @param token
 */
export function SetAllocationsToSubmit(allocations: AllocationType[]) {
  return {
    type: ALLOCATIONS.SET_ALLOCATIONS_TO_SUBMIT,
    allocations
  };
}

/**
 * Action type for setting the remaining amount allocation
 * @param token
 */
export function SetRemainingAmountAllocation(allocation: AllocationType) {
  return {
    type: ALLOCATIONS.SET_REMAINING_AMOUNT_ALLOCATION,
    allocation
  };
}

/**
 * Action type for resetting allocations state
 * @param token
 */
export function ResetAllocationsToSubmit() {
  return {
    type: ALLOCATIONS.RESET_ALLOCATIONS_TO_SUBMIT
  };
}

/**
 * Action type for resetting allocations state
 * @param token
 */
export function ResetAllocations() {
  return {
    type: ALLOCATIONS.RESET_ALLOCATIONS
  };
}

